// extracted by mini-css-extract-plugin
export default {"container":"time-entry-tab_container__R3d+7","refreshOverlay":"time-entry-tab_refreshOverlay__F2BWo"};